<template>
    <div class="component-centered" style="max-width:520px;margin:auto;padding-top:60px;">
        <v-card class="pa-6">
            <h1 class="text-h5 mb-4">Nouveau mot de passe</h1>

            <div v-if="!jeton">
                <v-alert type="error" variant="tonal" class="mb-4">
                    Cette adresse ne porte aucun jeton. Ouvrez le lien tel qu’il figure dans le
                    courriel, ou demandez-en un nouveau.
                </v-alert>
                <v-btn color="primary" block @click="demanderNouveauLien">
                    Demander un nouveau lien
                </v-btn>
            </div>

            <div v-else-if="fait">
                <v-alert type="success" variant="tonal" class="mb-4">
                    Votre mot de passe est enregistré. Vous pouvez vous connecter.
                </v-alert>
                <v-btn color="primary" block @click="retourConnexion">Aller à la connexion</v-btn>
            </div>

            <div v-else>
                <v-alert v-if="erreur" type="error" variant="tonal" class="mb-4">{{ erreur }}</v-alert>

                <v-text-field density="compact"
                              variant="outlined"
                              type="password"
                              label="Nouveau mot de passe"
                              autocomplete="new-password"
                              v-model="motDePasse"></v-text-field>

                <ul class="text-caption mb-4" style="list-style:none;padding-left:0;">
                    <li v-for="regle in regles" :key="regle.texte"
                        :style="{ color: regle.verifie(motDePasse) ? '#2e7d32' : '#757575' }">
                        {{ regle.verifie(motDePasse) ? '✓' : '·' }} {{ regle.texte }}
                    </li>
                </ul>

                <v-text-field density="compact"
                              variant="outlined"
                              type="password"
                              label="Confirmez le mot de passe"
                              autocomplete="new-password"
                              v-model="confirmation"
                              @keyup.enter="enregistrer"></v-text-field>

                <v-btn color="primary" block :loading="enCours" @click="enregistrer">
                    Enregistrer
                </v-btn>
            </div>
        </v-card>
    </div>
</template>

<script>
    import { defineComponent } from 'vue';
    import MotDePasse from '../script/MotDePasse.js';

    // Choix d'un nouveau mot de passe, depuis le lien recu par courriel.
    //
    // Le jeton vaut une heure et ne sert QU'UNE FOIS : il porte l'empreinte du mot de passe
    // en vigueur a son emission, donc il meurt des la premiere reinitialisation.
    export default defineComponent({
        data: function () {
            return {
                jeton: null,
                motDePasse: "",
                confirmation: "",
                erreur: null,
                fait: false,
                enCours: false,
                regles: [
                    { texte: "12 caractères au minimum", verifie: m => (m || "").length >= 12 },
                    { texte: "une majuscule", verifie: m => /[A-ZÀ-Þ]/.test(m || "") },
                    { texte: "une minuscule", verifie: m => /[a-zà-þ]/.test(m || "") },
                    { texte: "un chiffre", verifie: m => /[0-9]/.test(m || "") }
                ]
            };
        },
        mounted() {
            this.jeton = this.$route.query.jeton || null;

            // Le jeton sort de la barre d'adresse des qu'il est lu : il ne vaut qu'une heure
            // et qu'une fois, mais il n'a rien a faire dans un historique de navigation.
            if (this.jeton) {
                window.history.replaceState(null, "", "/reinitialisation");
            }
        },
        methods: {
            async enregistrer() {
                if (this.enCours) return;

                if (!this.regles.every(r => r.verifie(this.motDePasse))) {
                    this.erreur = "Le mot de passe ne respecte pas encore toutes les conditions ci-dessous.";
                    return;
                }

                if (this.motDePasse !== this.confirmation) {
                    this.erreur = "Les deux saisies ne correspondent pas.";
                    return;
                }

                this.erreur = null;
                this.enCours = true;
                try {
                    const reponse = await MotDePasse.reinitialiser(this.jeton, this.motDePasse);
                    if (reponse && reponse.success) {
                        this.fait = true;
                    } else {
                        this.erreur = (reponse && reponse.resMsg)
                            || "Ce lien n'est plus valable. Demandez-en un nouveau.";
                        this.motDePasse = "";
                        this.confirmation = "";
                    }
                } finally {
                    this.enCours = false;
                }
            },
            demanderNouveauLien() {
                this.$router.push({ name: 'MotDePasseOublie' });
            },
            retourConnexion() {
                this.$router.push({ name: 'Accueil' });
            }
        }
    });
</script>
